export default "__VITE_ASSET__Bni$GRac__"